"use client";

import type { PropsWithChildren } from "react";

import { ChakraProvider } from "@chakra-ui/react";
import { chakraTheme } from "./theme.chakra";

export const ClientChakraProvider = ({ children }: PropsWithChildren) => (
	<ChakraProvider theme={chakraTheme}>{children}</ChakraProvider>
);
